/* import __COLOCATED_TEMPLATE__ from './inline-comparison-counter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();